<template>
  <div class="tableTil">
    <h4>
      <p>
        <img src="../../assets/images/logo.png" />
      </p>
      <p><span>充电订单一览表</span></p>
      <p>
        <span>{{ formattedTime }} {{ formattedWeekday }}</span><span>数据刷新时间{{ time(mins) }}分钟</span>
      </p>
    </h4><!-- chargingList v-loadmore="loadmore"-->
    <el-card style="background: #306ac8; width: 98%; margin: 0 1%;height: 98vh;">
      <el-table :data="Alllist.slice(0, this.queryInfo.page * this.queryInfo.limit)" height="98vh" border
        :header-cell-style="titleMethods" 
        stripe
        empty-text="暂无电桩数据" ref="tableRef">
        <el-table-column align="center" label="序号" prop="gunNumber">
          <template slot-scope="scope">
                           
            <span>{{ scope.row.pileNo + '号桩'
              }}{{ scope.row.gunNumber == 1 ? 'A' : 'B' }}</span>
                         
          </template>
        </el-table-column>
        <el-table-column align="center" label="充电桩编号" prop="pileCode">
          <template slot-scope="scope">
                            <span>{{ scope.row.pileCode }}</span>              
          </template>
        </el-table-column>
        <el-table-column align="center" label="充电用户" prop="user">
          <template slot-scope="scope">
            <span>{{ stareName(scope.row.user) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="电量" prop="electric">
          <template slot-scope="scope">
            <span>{{ jisuan(scope.row.electric, 100, 2) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="功率" prop="chargeKwh">
          <template slot-scope="scope">
            <span>{{ jisuans(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="当前Soc" prop="soc">
          <template slot-scope="scope">
            <span>{{ typeName(scope.row.soc) }}%</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="启动时间" prop="Times">
          <template slot-scope="scope">
            <span>
              {{
          typeName(scope.row.Times)
        }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" prop="gunState">
          <template slot-scope="scope">
            <el-tag
              :text="typeIng(scope.row.commStatus, scope.row.gunNumber, scope.row.gunState, scope.row.gunToCarState)"
              :type="typeIng(scope.row.commStatus, scope.row.gunNumber, scope.row.gunState, scope.row.gunToCarState) == '充电' ? 'success' :
          typeIng(scope.row.commStatus, scope.row.gunNumber, scope.row.gunState, scope.row.gunToCarState) == '离线' ? 'default' :
            typeIng(scope.row.commStatus, scope.row.gunNumber, scope.row.gunState, scope.row.gunToCarState) == '故障' ? 'error' :
              typeIng(scope.row.commStatus, scope.row.gunNumber, scope.row.gunState, scope.row.gunToCarState) == '占用' || typeIng(scope.row.commStatus, scope.row.gunNumber, scope.row.gunState, scope.row.gunToCarState) == '插枪' ? 'warning' : 'primary'">
              {{ typeIng(scope.row.commStatus, scope.row.gunNumber, scope.row.gunState, scope.row.gunToCarState)
              }}</el-tag>
          </template>
        </el-table-column>
        <div slot="empty" class="empty">
          <span>暂无数据</span>
        </div>
      </el-table>
      <div v-if="loading" class="loading-tip">加载中...</div>
      <div v-if="!hasMore" class="no-more">没有更多数据了</div>
      <!-- 分页导航区域 -->
      <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="queryInfo.page" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="total" background>
      </el-pagination> -->
    </el-card>
  </div>
</template>
<script>
export default {
  name: '',
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      threshold: 100,
      loading: false,
      hasMore: true,
      chargingList: [],
      total: 0,
      queryInfo: {
        page: 1,
        limit: 20,
      },
      uuId: '',
      currentTime: new Date(),
      mins: 180000,
      timer: null,
      setTime: null,
      Alllist: [],
      billList: [],
      times:null
    }
  },

  computed: {
    jisuans() {
      return function (val) {
        return val.chargeKwh == null || val.chargeKwh == undefined || val.chargeKwh == '' ? 0 : val.pileType !== 5 ? (val.chargeKwh / 100000).toFixed(4) : val.chargeKwh
      }
    },
    typeIng() {
      return function (commStatus, gunNumber, gunState, gunToCarState) {
        if (commStatus == 0) return '离线';
        if (gunState == 0) {
          if (gunNumber == 1 && gunToCarState !== 0) return '占用';
          if (gunNumber == 2 && gunToCarState !== 0) return '占用';
          if (gunNumber == 1 && gunToCarState == 0) return '空闲';
          if (gunNumber == 2 && gunToCarState == 0) return '空闲';
        } else {
          // gunState=3,gunTocarState==0;
          if (gunNumber == 1 && gunState == 4) return '故障';
          if (gunNumber == 1 && gunState == 5) return '故障';
          if (gunNumber == 1 && gunState == 6) return '故障';
          if (gunNumber == 1 && gunState == 7) return '故障';
          if (gunNumber == 2 && gunState == 4) return '故障';
          if (gunNumber == 2 && gunState == 5) return '故障';
          if (gunNumber == 2 && gunState == 6) return '故障';
          if (gunNumber == 2 && gunState == 7) return '故障';
          return gunState == 3 ? '待拔枪' : '充电'
        }
      }
    },
    time() {
      return (obj) => {
        return obj == null || obj == '' ? '--' : (obj / 1000 / 60).toFixed(2)
      }
    },
    formattedWeekday() {
      const weekdays = [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六',
      ]
      return weekdays[this.currentTime.getDay()]
    },
    formattedTime() {
      const year = this.currentTime.getFullYear()
      const month = String(this.currentTime.getMonth() + 1).padStart(2, '0')
      const day = String(this.currentTime.getDate()).padStart(2, '0')
      let hours = this.currentTime.getHours()
      let ampm = ''
      if (!this.show24HourFormat) {
        ampm = hours >= 12 ? ' PM' : ' AM'
        hours = hours % 12
        hours = hours ? hours : 12
      }
      const minutes = String(this.currentTime.getMinutes()).padStart(2, '0')
      const seconds = String(this.currentTime.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${String(hours).padStart(
        2,
        '0'
      )}:${minutes}:${seconds}${ampm}`
    },
    typeName() {
      return (obj) => {
        return obj == null || obj == '' || obj == undefined ? '--' : obj
      }
    },
    stareName() {
      return (obj) => {
        return obj == null || obj == '' || obj == undefined ? '--' :obj.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
      };
    },
    jisuan() {
      return (obj, num, fixed) => {
        return obj == null || obj == '' || obj == undefined ? '--' : (obj / num).toFixed(fixed)
      }
    },
  },
  watch: {
    chargingList(newval) {
      this.chargingList = newval;
    },
  },
  beforeCreate() {
  },
  created() {
    this.uuId = this.$route.fullPath.split('/tableTil/')[1];
    this.com1();
    this.timer = setInterval(() => {
      this.currentTime = new Date()
    }, 1000)
    this.$http.get('sysConfig/getSysConfigBOById/83').then((ress) => {
      const res = ress.data;
      this.mins = res.code==0?Number(res.data.valueName): 180000;
      this.times=setInterval(()=>this.loadmore(), this.mins);
    });
  },

  mounted() {
    if (this.uuId == null || this.uuId == '') return;
    this.setTime = setInterval(() => this.com2(), this.mins)
  },

  beforeDestroy() {
    if (this.com2) {
      clearInterval(this.setTime)
    }
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.times) {
      clearInterval(this.times)
    }
  },
  methods: {
    loadmore() {
      this.queryInfo.limit += 20;
      this.handleSizeChange()
    },
    titleMethods({ row, column, rowIndex, columnIndex }) {
      return 'background:	#3B82F6; color:#fff;fontSize:24px'
    },
    // 监听pageSize改变的事件
    handleSizeChange() {
      // pageSize
      // 更新每页显示数量
      // this.queryInfo.limit = pageSize
      // 计算正确的分页区间（修正运算符优先级）
      const startIndex = (this.queryInfo.page - 1) * this.queryInfo.limit
      const endIndex = this.queryInfo.page * this.queryInfo.limit
      // 边界检查确保不超过数据范围
      const safeStart = Math.max(0, startIndex)
      const safeEnd = Math.min(this.Alllist.length, endIndex)
      // 更新当前页数据
      this.chargingList = this.Alllist.slice(safeStart, safeEnd)
      // 可选：触发数据更新通知
      this.$emit('page-change', {
        page: this.queryInfo.page,
        limit: this.queryInfo.limit,
      });
      this.com2()
    },
    // 监听页码值改变的事件
    handleCurrentChange(newPage) {
      // 边界检查确保页码有效
      newPage = Math.max(
        1,
        Math.min(newPage, Math.ceil(this.Alllist.length / this.queryInfo.limit))
      )
      this.queryInfo.page = newPage
      // 计算正确的分页区间
      const startIndex = (newPage - 1) * this.queryInfo.limit
      const endIndex = newPage * this.queryInfo.limit
      // 更新当前页数据
      this.chargingList = this.Alllist.slice(startIndex, endIndex);
      this.$emit('page-change', {
        page: newPage,
        limit: this.queryInfo.limit,
      });
      this.com2()
    },
    // 获取电站列表数据
    getPowerStationList() {
      this.$http
        .get('station-info/getAllStationInfo', {
          params: {
            page: 1,
            limit: 60,
            stationIds: '26,27',
            roleId: 5,
            stationMode: '0,1,2',
          },
        })
        .then((ress) => {
          const res = ress.data
          if (ress.code > 0) return
          this.uuId = res.data
            .map((item) => {
              return item.uuId
            })
            .join(',')
          this.com1()
        })
    },
    com1() {
      this.$http
        .get(`08F468B0978D4152B9FF0FE07A51616A280XSH09/${this.uuId}`)
        .then((ress) => {
          const res = ress.data
          this.Alllist = res.data
            .flatMap((item) => item.pileList || [])
            .concat(
              Array(this.Alllist.length).fill({
                user: '',
                electric: '', // 修正拼写错误(eletric->electric)
                soc: '',
                Times: '',
              })
            )
          this.total = this.Alllist.length;
          this.handleCurrentChange(1)
        })
    },
    com2() {
      const that = this;
      that.$http.get(`17AC33DA36054CB7B07FC5FD75089D4FPRH6GWQK/${that.uuId}`).then(ress => {
        const res = ress.data;
        if (res.code > 0) return;
        that.billList = res.data.flatMap((item) => item.billList || [])
        if (that.billList.length > that.chargingList.length) return;
        // 使用双重循环查找匹配项
        that.chargingList.forEach((element, i) => {
          that.billList.forEach((til) => {
            // 修正原代码中错误的数组访问方式
            if (
              element.pileCode === til.pileCode &&
              element.gunNumber === til.gunNumber
            ) {
              element.user = til.phone
              element.soc = til.nowSoc
              element.electric = til.totalKwh
              element.Times = til.startTime
              that.$set(that.chargingList[i], that.chargingList[i].user, til.phone);
              that.$set(that.chargingList[i], that.chargingList[i].soc, til.nowSoc);
              that.$set(that.chargingList[i], that.chargingList[i].electric, til.totalKwh);
              that.$set(that.chargingList[i], that.chargingList[i].Times, til.startTime);
            }
          })
        })
      })
    },
    async getChargingOrderList() { },
    // 批量删除的复选框改变事件
    handleSelectionChange(value) {
      if (value.length > 0) {
        this.ids = ''
        value.forEach((item) => {
          this.ids += item.id + ','
        })
        this.ids = this.ids.substring(0, this.ids.length - 1)
      } else {
        return false
      }
    },
  }
};
</script>

<style lang="less" scoped>
.tableTil {
  width: 100%;
  height: 100%;
  background: #306ac8;
  overflow-y: scroll;

  ::v-deep {
    .el-table__empty-text .empty span {
      color: #fff;
      font-size: 24px !important;
    }

    .el-table .cell {
      line-height: 35px;

      span {
        font-size: 20px !important;
        font-weight: bolder !important;
      }
    }

    .el-table__empty-block {
      background: #306ac8;
    }

    .el-select {
      width: 180px;

      .el-input__inner {
        width: 180px !important;
        font-size: 20px !important;
        display: flex !important;
        flex-direction: row !important;
        justify-content: space-between !important;
      }
    }

    .el-input--mini .el-input__icon {
      color: #fff !important;
      font-size: 18px !important;
    }

    .el-icon el-icon-arrow-left {
      font-size: 18px !important;
    }

    .el-pagination .btn-next .el-icon,
    .el-pagination .btn-prev .el-icon {
      font-size: 18px;
    }

    .el-pagination button {
      width: 40px;
      height: 35px;

      .el-pagination span {
        line-height: normal;
        vertical-align: bottom;
        font-size: 20px !important;
        color: #fff;
      }
    }

    .el-pagination__total {
      color: #fff;
      font-size: 20px !important;
      vertical-align: bottom;
    }

    .el-pager li {
      width: 60px;
      height: 35px;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .el-input__inner,
    html .el-input__inner,
    #app .el-input__inner {
      width: 120px !important;
      background: #3b82f6;
      color: #fff;
    }

    .el-pagination__jump {
      width: 240px;
      font-size: 18px !important;
      color: #fff;
    }
  }

  h4 {
    display: flex;
    padding: 0 1%;
    flex-direction: row;
    height: 100px;
    width: 98%;
    justify-content: space-between;

    p {
      height: 100px;
      display: flex;
      align-items: center;
      color: #fff;

      img {
        width: 240px;
        height: 80px;
      }
    }

    p:nth-child(2)>span {
      font-size: 32px !important;
    }

    p:nth-child(3) {
      flex-direction: column;

      span {
        flex: 1;
        color: #13ce66;
      }

      span {
        font-size: 24px !important;
      }

      span:nth-child(2) {
        color: #fff;
      }
    }
  }
}
</style>